import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ConfigurationStateContext } from "../store/configurationState/ConfigurationStateProvider";
import { GlobeIcon } from "./Icons";

const getLanguageList = (i18n: any): string[] => {
  return Object.keys(i18n.options.resources || i18n.services.resourceStore.data);
};

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();
  const { configurationState } = useContext(ConfigurationStateContext);

  const languages = getLanguageList(i18n);
  const currentLang = i18n.language || languages[0];
  const currentIndex = languages.indexOf(currentLang);
  const nextLang = languages[(currentIndex + 1) % languages.length];
 
  const [ canChangeLanguage, setCanChangeLanguage ] = useState(true);
  
  useEffect(() => {
    if (!configurationState.configurationLoaded || !configurationState.preferredLanguage) return;

    if (configurationState.preferredLanguage !== currentLang) {
      // Check that language is one of the supported ones
      if (!languages.includes(configurationState.preferredLanguage)) {
        console.error(`Unsupported language: ${configurationState.preferredLanguage}. Supported languages: ${languages.join(", ")}`);
      }
      else {
        
        i18n.changeLanguage(configurationState.preferredLanguage);
      }
    }
    
    setCanChangeLanguage(false); // If we have a language param, we assume language selection is done in parent app (coreclient, customer journey)

  }, [configurationState]);

  const handleClick = () => {
    i18n.changeLanguage(nextLang);
  };

  return (
    <>
    {canChangeLanguage && (
    <div className="languageSelector">
      <button
        onClick={handleClick}
        title="Change language"
        style={{
          width: 32,
          height: 32,
          borderRadius: "50%",
          background: "#f0f0f0",

          border: "none",
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
          cursor: "pointer",
          alignItems: "center",
          justifyContent: "center",
          transition: "background 0.2s",
          outline: "none",
        }}
        onMouseOver={e => (e.currentTarget.style.background = "#999999", e.currentTarget.style.opacity = "1")}
        onMouseOut={e => (e.currentTarget.style.background = "#f0f0f0", e.currentTarget.style.opacity = "0")}
        aria-label="Change language"
      >
        <GlobeIcon size={32} />
        <span
          style={{
            position: "absolute",
            fontWeight: 700,
            fontSize: 10,
            color: "#1976d2",
            pointerEvents: "none",
            userSelect: "none",
            alignItems: "center",
          justifyContent: "center",
          }}
        >
          {currentLang.toUpperCase()}
        </span>
      </button>
    </div>
  )
  }
  </>
  );
};

export default LanguageSelector;